import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Wheelchair(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_657_40)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 2.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM7.25 3.5a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zm2.723 5.25a.97.97 0 00-.971.97v5.04a2.25 2.25 0 002.25 2.25h4.014a2.75 2.75 0 011.779.653l2.931 2.486a1.012 1.012 0 101.282-1.567l-3.905-3.078a2.25 2.25 0 00-1.393-.483h-4.267a.75.75 0 01-.75-.75V9.72a.97.97 0 00-.97-.971zm-2.471.97a2.47 2.47 0 114.941 0v3.8h3.517c.842 0 1.66.284 2.321.806l3.905 3.078a2.512 2.512 0 11-3.18 3.889l-2.931-2.486a1.25 1.25 0 00-.809-.297h-4.014a3.75 3.75 0 01-3.75-3.75V9.72zm-2.006 1.148a1 1 0 10-.992-1.736c-1.1.628-1.968 1.714-2.557 2.909C1.353 13.245 1 14.645 1 16a8 8 0 008 8c2.164 0 4.247-.862 5.7-2.286a1 1 0 10-1.4-1.428C12.228 21.336 10.65 22 9 22a6 6 0 01-6-6c0-1.024.272-2.123.74-3.075.474-.96 1.106-1.685 1.756-2.057z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_657_40"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Wheelchair;